import AudioIcon from '@assets/icons/audio.svg';
import EmailIcon from '@assets/icons/email.svg';
import ImageIcon from '@assets/icons/file-image-small.svg';
import SmsIcon from '@assets/icons/sms.svg';
import VoicemailIcon from '@assets/icons/voicemail.svg';
import { AttachmentMimeType } from '@/screens/order-inbounds/types';
import { type FC, ReactNode, useMemo } from 'react';
import { type OrderInboundsDetailTabsRoute } from './types';
import { StyleSheet, View } from 'react-native';
import { type TabDescriptor } from 'react-native-tab-view';
import { Typography } from '@usepepper/ui/atoms/typography';

type TabDescriptorProps = Parameters<
  NonNullable<TabDescriptor<OrderInboundsDetailTabsRoute>['label']>
>[0];

interface Props extends TabDescriptorProps {}

export const OrderInboundsDetailTabsLabel: FC<Props> = ({ color, route }) => {
  const tabIcon: ReactNode = useMemo(() => {
    switch (route.type) {
      case 'ATTACHMENT':
        switch (route.attachment.mimeType) {
          case AttachmentMimeType.EML:
            return <EmailIcon height={16} stroke={color} width={16} />;
          case AttachmentMimeType.GIF:
          case AttachmentMimeType.JPG:
          case AttachmentMimeType.PNG:
          case AttachmentMimeType.HEIC:
          case AttachmentMimeType.WEBP:
            return <ImageIcon fill={color} height={16} width={16} />;
          default:
            return null;
        }
      case 'AUDIO_ATTACHMENT':
        return <AudioIcon height={16} stroke={color} width={16} />;
      case 'VOICEMAIL':
        return <VoicemailIcon fill={color} />;
      case 'MESSAGE':
        return <SmsIcon fill={color} />;
      case 'GROUPED_IMAGES':
        return <ImageIcon fill={color} height={16} width={16} />;
      case 'GROUPED_HTML':
        return null;
      case 'EMAIL_THREAD':
        return <EmailIcon height={16} stroke={color} width={16} />;
      default:
        return null;
    }
  }, [route, color]);

  return (
    <View style={styles.container}>
      {tabIcon}

      <Typography color={color} variant="label-md">
        {route.title}
      </Typography>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
});
